import request from '@/utils/request'
import { IVendor } from './types-vendor'

const BASE_ROUTE = 'api/v1/vendor/'

export const getDashboard = () =>
  request({
    url: BASE_ROUTE + 'dashboard',
    method: 'get'
  })

export const getVendors = () =>
  request({
    url: BASE_ROUTE + 'list',
    method: 'get'
  })

export const getVendorsByLocation = (data: any) =>
  request({
    url: BASE_ROUTE + 'bylocation',
    method: 'post',
    data
  })

export const getVendor = (id: number) =>
  request({
    url: BASE_ROUTE + `${id}`,
    method: 'get'
  })

export const getVendorHistory = (id: number) =>
  request({
    url: BASE_ROUTE + `${id}/history`,
    method: 'post'
  })

export const updateVendor = (id: number, data: any) =>
  request({
    url: BASE_ROUTE + `${id}/update`,
    method: 'post',
    data
  })

export const deleteVendor = (id: number) =>
  request({
    url: BASE_ROUTE + `${id}/deactivate`,
    method: 'post'
  })

// Vendor Coverage sets
export const getVendorCoverageSets = (id: number) =>
  request({
    url: BASE_ROUTE + `${id}/coverage-sets`,
    method: 'get'
  })

export const getVendorCoverageSet = (id: number, sid: number) =>
  request({
    url: BASE_ROUTE + `${id}/coverage-sets/${sid}`,
    method: 'get'
  })

export const updateVendorCoverageSetZipList = (id: number, sid: number, data: any) =>
  request({
    url: BASE_ROUTE + `${id}/coverage-sets/${sid}/zip-list`,
    method: 'post',
    data
  })

export const getZipsByRadius = (id: number, radius: number) =>
  request({
    url: BASE_ROUTE + `${id}/zips-by-radius/${radius}`,
    method: 'get'
  })

// Vendor Coverages
export const addVendorCoverage = (id: number, sid: number, cid: number, data: any) =>
  request({
    url: BASE_ROUTE + `${id}/coverage-sets/${sid}/products/${cid}/add`,
    method: 'post',
    data
  })

export const saveAllVendorCoverage = (id: number, sid: number, data: any) =>
  request({
    url: BASE_ROUTE + `${id}/coverage-sets/${sid}/coverages/all`,
    method: 'post',
    data
  })

export const deleteVendorCoverage = (id: number, sid: number, cid: number) =>
  request({
    url: BASE_ROUTE + `${id}/coverage-sets/${sid}/coverages/${cid}/delete`,
    method: 'post'
  })

export const deleteVendorCoverageList = (id: number, sid: number, data: any) =>
  request({
    url: BASE_ROUTE + `${id}/coverage-sets/${sid}/coverages/delete`,
    method: 'post',
    data
  })

export const updateVendorCoverage = (id: number, sid: number, cid: number, data: any) =>
  request({
    url: BASE_ROUTE + `${id}/coverage-sets/${sid}/coverages/${cid}`,
    method: 'post',
    data
  })

// VENDOR LICENSE
export const addVendorLicense = (id: number, data: any) =>
  request({
    url: BASE_ROUTE + `${id}/license/add`,
    method: 'post',
    data
  })

export const deleteVendorLicenseList = (id: number, data: any) =>
  request({
    url: BASE_ROUTE + `${id}/license/delete`,
    method: 'post',
    data
  })

export const getVendorLicenses = (id: number) =>
  request({
    url: BASE_ROUTE + `${id}/license/list`,
    method: 'get'
  })

export const updateVendorLicense = (id: number, licenseId: number, data: any) =>
  request({
    url: BASE_ROUTE + `${id}/license/${licenseId}/update`,
    method: 'post',
    data
  })

export const deleteVendorLicense = (id: number, licenseId: number) =>
  request({
    url: BASE_ROUTE + `${id}/license/${licenseId}/delete`,
    method: 'post'
  })

export const getVendorLicenseTypes = () =>
  request({
    url: BASE_ROUTE + 'vendor-license-types',
    method: 'get'
  })

// VENDOR ROLES
export const getVendorRoles = () =>
  request({
    url: BASE_ROUTE + 'vendor-roles',
    method: 'get'
  })

export const getVendorStatuses = () =>
  request({
    url: BASE_ROUTE + 'vendor-statuses',
    method: 'get'
  })

export const getVendorTypes = () =>
  request({
    url: BASE_ROUTE + 'vendor-types',
    method: 'get'
  })

export const createIndependentVendor = (vendor: IVendor) =>
  request({
    url: BASE_ROUTE + 'create/independent',
    method: 'post',
    data: vendor
  })
